import type { ReactNode } from 'react';

export interface FooterSocialProps {
  children: ReactNode;
  'aria-label': string;
}

export function FooterSocial({ children, ...rest }: FooterSocialProps) {
  return (
    <nav aria-label={rest['aria-label']} className="flex items-center justify-center gap-3">
      {children}
    </nav>
  );
}
